import { ColorModeScript } from "@chakra-ui/react";
import * as React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "@utils/i18n";
import { Provider } from "react-redux";
import { store } from "@src/store";


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ColorModeScript />
            <App />
        </Provider>
    </React.StrictMode>
);
